import React from 'react';
import {NativeSyntheticEvent, StyleProp, TextInputSubmitEditingEventData, TextStyle, ViewStyle} from 'react-native';
import {WrappedFieldInputProps, WrappedFieldMetaProps, GenericFieldHTMLAttributes} from 'redux-form';
import {DictionaryItem} from '../../dictionaries/model';
import {BaseFieldSelectOwnProps} from './components/select/model';

export enum InputMaskTypes {
  tel = '8 (999) 999 99 99',
  card = '9999 9999 9999 9999',
  snils = '999-999-999 99',
  inn = '999 999 999 999',
}

export type BaseFieldVariant = 'standard' | 'outlined';

export type BaseFieldProps = {
  testIDprefix?: string;
  input: Partial<WrappedFieldInputProps>;
  meta?: WrappedFieldMetaProps;
  label?: string;
  placeholder?: string;
  mask?: string;
  type:
    | 'text'
    | 'number'
    | 'phone'
    | 'hidden'
    | 'password'
    | 'checkbox'
    | 'radio'
    | 'digits'
    | 'date'
    | 'select'
    | 'selectDinamic';
  values?: DictionaryItem[];
  variant?: BaseFieldVariant;
  multiline?: boolean;
  rowsMax?: number;
  rows?: number;
  maxLength?: number;
  autoFocus?: boolean;
  hint?: string;
  halfWidth?: boolean;
  autoCapitalize: 'words' | 'none' | 'sentences' | 'characters';
  customStyles?: object;
  dotStyle?: ViewStyle;
  readOnly?: boolean;
  smallHeight?: boolean;
  disableErrorIcon?: boolean;
  right?: JSX.Element;
  rightStyle?: any;
  left?: JSX.Element;
  leftStyle?: StyleProp<ViewStyle>;
  labelStyle?: StyleProp<TextStyle>;
  inputContainerStyle?: StyleProp<ViewStyle>;
  containerStyle?: StyleProp<ViewStyle>;
  setAddress?: React.Dispatch<React.SetStateAction<string>>;
  onCustomBlur(event: any, formName?: string, fieldName?: string, newValue?: any): Promise<void> | void;
  onSubmitEditing?: (event: NativeSyntheticEvent<TextInputSubmitEditingEventData>) => void;
  baseColor?: string;
} & GenericFieldHTMLAttributes &
  BaseFieldSelectOwnProps;
